import Vue from "vue";

import VueMoment from "vue-moment";
import VModal from "vue-js-modal";
import * as moment from "moment";
import VueScrollTo from "vue-scrollto";
import "moment/locale/fr";
import { i18n } from "@/i18n";
import { store } from "@/store";
import { router } from "@/router";
import App from "@/views/App/App.vue";
import ScrollSync from "vue-scroll-sync";
import Toasted from "vue-toasted";
import VTooltip from "v-tooltip";

Vue.config.performance = process.env.NODE_ENV !== "production";

Vue.use(VueMoment, { moment });
Vue.use(VModal);
Vue.use(ScrollSync);
Vue.use(Toasted);
Vue.use(VueScrollTo);
Vue.use(VTooltip);

const app = new Vue({
    i18n,
    store,
    router,
    render: (h) => h(App),
});

export { app };

if (module.hot) {
    module.hot.accept();
}
